import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Header } from "./components";
import { createContext, useEffect } from "react";
import { Footer } from "./components/footer/Footer";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { getSBTSCheckoutRoutes } from "./common/routes";
import { AccessDenied } from "./pages/AccessDenied/AccessDenied";
import { useAuth } from "./hooks/useAuth";
import LoadingContent from "./components/LoadingContent/LoadingContent";
import { I18nextProvider } from "react-i18next";
import i18n from '../i18n/config';
import CookieConsentManager from "./cookieManagement/CookieConsentManager";
import { SessionKey } from "./common/constants";
import { getMarketingTrackingInfo } from "./common/utilityFunctions";
import { triggerAnalyticsEvent } from "./analytics/createEventTrigger";
import { getNodeEnvironment } from "./common/nodeEnvironment";
export const UserContext = createContext(undefined);
function App() {
    let { user, isAuthErrorFound } = useAuth();
    const cookieConsentManager = new CookieConsentManager();
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        // Check for marketing tracking parameters
        const trackingInfo = getMarketingTrackingInfo(location.search);
        if (trackingInfo) {
            // Trigger Adobe Analytics event
            triggerAnalyticsEvent('pageView', `SBTS_${getNodeEnvironment()} | marketing_redirect | ${trackingInfo.source} | ${trackingInfo.location}`);
        }
        cookieConsentManager.checkForCookieConsent();
    }, [location]);
    // If user email not found and no auth error then show the loading page
    if (!user.email && !isAuthErrorFound) {
        return _jsx(LoadingContent, { text: "Loading" });
    }
    else {
        sessionStorage.setItem(SessionKey.OTP_EMAIL, user.email);
        triggerAnalyticsEvent('click', `SBTS_${getNodeEnvironment()} | email_otp | authentication | event_succeeded`);
    }
    const handleLanguageChange = (language) => {
        i18n.changeLanguage(language);
        sessionStorage.setItem(SessionKey.LANGUAGE, language);
    };
    sessionStorage.setItem(SessionKey.LANGUAGE, 'en-US');
    return (_jsx(I18nextProvider, { i18n: i18n, children: _jsxs(UserContext.Provider, { value: user, children: [_jsx(Header, { onLanguageChange: handleLanguageChange }), isAuthErrorFound ? (_jsx(AccessDenied, {})) : (_jsxs(Routes, { children: [...getSBTSCheckoutRoutes().map((route) => (_jsx(Route, { path: route.path, element: route.element }, route.path)))] })), _jsx(Footer, {})] }) }));
}
;
export default App;
